/* tslint:disable */
/* eslint-disable */
/**
 * JSK
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * メッセージ作成データ
 * @export
 * @interface CreateMessage
 */
export interface CreateMessage {
    /**
     * ユーザーID
     * @type {number}
     * @memberof CreateMessage
     */
    'nd_member_user_id': number;
    /**
     * 加盟店ID
     * @type {number}
     * @memberof CreateMessage
     */
    'jsk_vendor_id': number;
    /**
     * 内容
     * @type {string}
     * @memberof CreateMessage
     */
    'content': string;
    /**
     * 添付ファイル名
     * @type {string}
     * @memberof CreateMessage
     */
    'file_name'?: string;
    /**
     * 添付ファイルパス
     * @type {string}
     * @memberof CreateMessage
     */
    'file_path'?: string;
    /**
     * 宛先
     * @type {Array<number>}
     * @memberof CreateMessage
     */
    'destinations'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ExportVendor200Response
 */
export interface ExportVendor200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof ExportVendor200Response
     */
    'info': ResponseInfo;
    /**
     * CSVデータ
     * @type {string}
     * @memberof ExportVendor200Response
     */
    'payload': string;
}
/**
 * 
 * @export
 * @interface GetCsrf200Response
 */
export interface GetCsrf200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetCsrf200Response
     */
    'info': ResponseInfo;
    /**
     * CSRFトークン
     * @type {string}
     * @memberof GetCsrf200Response
     */
    'payload': string;
}
/**
 * 
 * @export
 * @interface GetFile200Response
 */
export interface GetFile200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetFile200Response
     */
    'info': ResponseInfo;
    /**
     * URL
     * @type {string}
     * @memberof GetFile200Response
     */
    'payload': string;
}
/**
 * 
 * @export
 * @interface GetFileUploadRequest200Response
 */
export interface GetFileUploadRequest200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetFileUploadRequest200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {GetFileUploadRequest200ResponsePayload}
     * @memberof GetFileUploadRequest200Response
     */
    'payload': GetFileUploadRequest200ResponsePayload;
}
/**
 * 
 * @export
 * @interface GetFileUploadRequest200ResponsePayload
 */
export interface GetFileUploadRequest200ResponsePayload {
    /**
     * パス
     * @type {string}
     * @memberof GetFileUploadRequest200ResponsePayload
     */
    'path': string;
    /**
     * フォーム属性
     * @type {{ [key: string]: any; }}
     * @memberof GetFileUploadRequest200ResponsePayload
     */
    'form_attributes': { [key: string]: any; };
    /**
     * フォームデータ
     * @type {object}
     * @memberof GetFileUploadRequest200ResponsePayload
     */
    'form_inputs': object;
}
/**
 * 
 * @export
 * @interface GetJskAccidentLocationSettingCollection200Response
 */
export interface GetJskAccidentLocationSettingCollection200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetJskAccidentLocationSettingCollection200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {GetJskAccidentLocationSettingCollection200ResponsePayload}
     * @memberof GetJskAccidentLocationSettingCollection200Response
     */
    'payload': GetJskAccidentLocationSettingCollection200ResponsePayload;
}
/**
 * 
 * @export
 * @interface GetJskAccidentLocationSettingCollection200ResponsePayload
 */
export interface GetJskAccidentLocationSettingCollection200ResponsePayload {
    /**
     * 
     * @type {Array<GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner>}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayload
     */
    'collection': Array<GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner>;
    /**
     * 現在のページ
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayload
     */
    'current_page': number;
    /**
     * 合計のページ
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayload
     */
    'total_pages': number;
    /**
     * 合計数
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayload
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
 */
export interface GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner {
    /**
     * 事故種別ID
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'id': number;
    /**
     * 事故種別名
     * @type {string}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'name': string;
    /**
     * 選択可能期間
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'select_year': number;
    /**
     * 事故箇所1選択フラグ
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_location_select_flag1': number;
    /**
     * 事故箇所1設定数
     * @type {string}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_location_select_count1': string;
    /**
     * 事故箇所2選択フラグ
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_location_select_flag2': number;
    /**
     * 事故箇所2設定数
     * @type {string}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_location_select_count2': string;
    /**
     * 事故箇所3選択フラグ
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_location_select_flag3': number;
    /**
     * 事故箇所3設定数
     * @type {string}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_location_select_count3': string;
    /**
     * 事故部位1選択フラグ
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_part_select_flag1': number;
    /**
     * 事故部位1設定数
     * @type {string}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_part_select_count1': string;
    /**
     * 事故部位2選択フラグ
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_part_select_flag2': number;
    /**
     * 事故部位2設定数
     * @type {string}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'accident_part_select_count2': string;
    /**
     * 削除フラグ
     * @type {number}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'deleted': number;
    /**
     * 登録日時
     * @type {string}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'created': string;
    /**
     * 更新日時
     * @type {string}
     * @memberof GetJskAccidentLocationSettingCollection200ResponsePayloadCollectionInner
     */
    'modified': string;
}
/**
 * 
 * @export
 * @interface GetMessageCollection200Response
 */
export interface GetMessageCollection200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetMessageCollection200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {GetMessageCollection200ResponsePayload}
     * @memberof GetMessageCollection200Response
     */
    'payload': GetMessageCollection200ResponsePayload;
}
/**
 * 
 * @export
 * @interface GetMessageCollection200ResponsePayload
 */
export interface GetMessageCollection200ResponsePayload {
    /**
     * 
     * @type {Array<Message>}
     * @memberof GetMessageCollection200ResponsePayload
     */
    'collection': Array<Message>;
    /**
     * 合計数
     * @type {number}
     * @memberof GetMessageCollection200ResponsePayload
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface GetMessageData200Response
 */
export interface GetMessageData200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetMessageData200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {GetMessageData200ResponsePayload}
     * @memberof GetMessageData200Response
     */
    'payload': GetMessageData200ResponsePayload;
}
/**
 * 
 * @export
 * @interface GetMessageData200ResponsePayload
 */
export interface GetMessageData200ResponsePayload {
    /**
     * 
     * @type {Array<Message>}
     * @memberof GetMessageData200ResponsePayload
     */
    'collection'?: Array<Message>;
}
/**
 * 
 * @export
 * @interface GetNewsCollection200Response
 */
export interface GetNewsCollection200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetNewsCollection200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {GetNewsCollection200ResponsePayload}
     * @memberof GetNewsCollection200Response
     */
    'payload': GetNewsCollection200ResponsePayload;
}
/**
 * 
 * @export
 * @interface GetNewsCollection200ResponsePayload
 */
export interface GetNewsCollection200ResponsePayload {
    /**
     * 
     * @type {Array<News>}
     * @memberof GetNewsCollection200ResponsePayload
     */
    'collection': Array<News>;
    /**
     * 現在のページ
     * @type {number}
     * @memberof GetNewsCollection200ResponsePayload
     */
    'current_page': number;
    /**
     * 合計のページ
     * @type {number}
     * @memberof GetNewsCollection200ResponsePayload
     */
    'total_pages': number;
    /**
     * 合計数
     * @type {number}
     * @memberof GetNewsCollection200ResponsePayload
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface GetNewsData200Response
 */
export interface GetNewsData200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetNewsData200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {News}
     * @memberof GetNewsData200Response
     */
    'payload': News;
}
/**
 * 
 * @export
 * @interface GetNotification200Response
 */
export interface GetNotification200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetNotification200Response
     */
    'info': ResponseInfo;
    /**
     * 通知データ
     * @type {Notification}
     * @memberof GetNotification200Response
     */
    'payload': Notification;
}
/**
 * 
 * @export
 * @interface GetOptionPrefecture200Response
 */
export interface GetOptionPrefecture200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetOptionPrefecture200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {Array<Option>}
     * @memberof GetOptionPrefecture200Response
     */
    'payload': Array<Option>;
}
/**
 * 
 * @export
 * @interface GetSession200Response
 */
export interface GetSession200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetSession200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {GetSession200ResponsePayload}
     * @memberof GetSession200Response
     */
    'payload': GetSession200ResponsePayload;
}
/**
 * 
 * @export
 * @interface GetSession200ResponsePayload
 */
export interface GetSession200ResponsePayload {
    /**
     * 
     * @type {User}
     * @memberof GetSession200ResponsePayload
     */
    'user': User;
    /**
     * 権限データ
     * @type {Array<Permission>}
     * @memberof GetSession200ResponsePayload
     */
    'permissions': Array<Permission>;
}
/**
 * 
 * @export
 * @interface GetSession422Response
 */
export interface GetSession422Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetSession422Response
     */
    'info': ResponseInfo;
}
/**
 * 
 * @export
 * @interface GetVendorCollection200Response
 */
export interface GetVendorCollection200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetVendorCollection200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {GetVendorCollection200ResponsePayload}
     * @memberof GetVendorCollection200Response
     */
    'payload': GetVendorCollection200ResponsePayload;
}
/**
 * 
 * @export
 * @interface GetVendorCollection200ResponsePayload
 */
export interface GetVendorCollection200ResponsePayload {
    /**
     * 
     * @type {Array<VendorForCollection>}
     * @memberof GetVendorCollection200ResponsePayload
     */
    'collection': Array<VendorForCollection>;
    /**
     * 現在のページ
     * @type {number}
     * @memberof GetVendorCollection200ResponsePayload
     */
    'current_page': number;
    /**
     * 合計のページ
     * @type {number}
     * @memberof GetVendorCollection200ResponsePayload
     */
    'total_pages': number;
    /**
     * 合計数
     * @type {number}
     * @memberof GetVendorCollection200ResponsePayload
     */
    'total_count': number;
}
/**
 * 
 * @export
 * @interface GetVendorData200Response
 */
export interface GetVendorData200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetVendorData200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {Vendor}
     * @memberof GetVendorData200Response
     */
    'payload': Vendor;
}
/**
 * 
 * @export
 * @interface GetVendorMember200Response
 */
export interface GetVendorMember200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof GetVendorMember200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetVendorMember200Response
     */
    'payload': Array<object>;
}
/**
 * 損害サービス・箇所設定データ
 * @export
 * @interface JskAccidentLocationSetting
 */
export interface JskAccidentLocationSetting {
    /**
     * 事故種別ID
     * @type {number}
     * @memberof JskAccidentLocationSetting
     */
    'id': number;
    /**
     * 事故種別名
     * @type {string}
     * @memberof JskAccidentLocationSetting
     */
    'name': string;
    /**
     * 選択可能期間
     * @type {number}
     * @memberof JskAccidentLocationSetting
     */
    'select_year': number;
    /**
     * 事故箇所1選択フラグ
     * @type {number}
     * @memberof JskAccidentLocationSetting
     */
    'accident_location_select_flag1': number;
    /**
     * 事故箇所1設定数
     * @type {string}
     * @memberof JskAccidentLocationSetting
     */
    'accident_location_select_count1': string;
    /**
     * 事故箇所2選択フラグ
     * @type {number}
     * @memberof JskAccidentLocationSetting
     */
    'accident_location_select_flag2': number;
    /**
     * 事故箇所2設定数
     * @type {string}
     * @memberof JskAccidentLocationSetting
     */
    'accident_location_select_count2': string;
    /**
     * 事故箇所3選択フラグ
     * @type {number}
     * @memberof JskAccidentLocationSetting
     */
    'accident_location_select_flag3': number;
    /**
     * 事故箇所3設定数
     * @type {string}
     * @memberof JskAccidentLocationSetting
     */
    'accident_location_select_count3': string;
    /**
     * 事故部位1選択フラグ
     * @type {number}
     * @memberof JskAccidentLocationSetting
     */
    'accident_part_select_flag1': number;
    /**
     * 事故部位1設定数
     * @type {string}
     * @memberof JskAccidentLocationSetting
     */
    'accident_part_select_count1': string;
    /**
     * 事故部位2選択フラグ
     * @type {number}
     * @memberof JskAccidentLocationSetting
     */
    'accident_part_select_flag2': number;
    /**
     * 事故部位2設定数
     * @type {string}
     * @memberof JskAccidentLocationSetting
     */
    'accident_part_select_count2': string;
    /**
     * 削除フラグ
     * @type {number}
     * @memberof JskAccidentLocationSetting
     */
    'deleted': number;
    /**
     * 登録日時
     * @type {string}
     * @memberof JskAccidentLocationSetting
     */
    'created': string;
    /**
     * 更新日時
     * @type {string}
     * @memberof JskAccidentLocationSetting
     */
    'modified': string;
}
/**
 * メッセージデータ
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * チャットID
     * @type {number}
     * @memberof Message
     */
    'id': number;
    /**
     * ユーザーID
     * @type {number}
     * @memberof Message
     */
    'nd_member_user_id': number;
    /**
     * 加盟店ID
     * @type {number}
     * @memberof Message
     */
    'jsk_vendor_id': number;
    /**
     * 名前
     * @type {string}
     * @memberof Message
     */
    'name': string;
    /**
     * 加盟店名
     * @type {string}
     * @memberof Message
     */
    'vendor_name'?: string;
    /**
     * 権限データ
     * @type {Array<string>}
     * @memberof Message
     */
    'permissions': Array<string>;
    /**
     * 宛先
     * @type {Array<string>}
     * @memberof Message
     */
    'destinations': Array<string>;
    /**
     * 内容
     * @type {string}
     * @memberof Message
     */
    'content': string;
    /**
     * 添付ファイル名
     * @type {string}
     * @memberof Message
     */
    'file_name'?: string;
    /**
     * 添付ファイルパス
     * @type {string}
     * @memberof Message
     */
    'file_path'?: string;
    /**
     * 添付ファイルURL
     * @type {string}
     * @memberof Message
     */
    'file_url'?: string;
    /**
     * 削除フラグ
     * @type {number}
     * @memberof Message
     */
    'deleted_flag': number;
    /**
     * 作成日時
     * @type {string}
     * @memberof Message
     */
    'created': string;
    /**
     * 更新日時
     * @type {string}
     * @memberof Message
     */
    'modified': string;
}
/**
 * お知らせデータ
 * @export
 * @interface News
 */
export interface News {
    /**
     * お知らせID
     * @type {number}
     * @memberof News
     */
    'id': number;
    /**
     * タイトル
     * @type {string}
     * @memberof News
     */
    'title': string;
    /**
     * 本文
     * @type {string}
     * @memberof News
     */
    'body': string;
    /**
     * 公開日時
     * @type {string}
     * @memberof News
     */
    'publish_date': string;
    /**
     * 作成日時
     * @type {string}
     * @memberof News
     */
    'created': string;
    /**
     * 更新日時
     * @type {string}
     * @memberof News
     */
    'modified': string;
}
/**
 * 通知データ
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * メッセージ
     * @type {Array<number>}
     * @memberof Notification
     */
    'message': Array<number>;
}
/**
 * オプションデータ
 * @export
 * @interface Option
 */
export interface Option {
    /**
     * 表示名
     * @type {string}
     * @memberof Option
     */
    'label': string;
    /**
     * 値
     * @type {string}
     * @memberof Option
     */
    'value': string;
}
/**
 * ページネーションデータ
 * @export
 * @interface PaginationInfo
 */
export interface PaginationInfo {
    /**
     * 現在のページ
     * @type {number}
     * @memberof PaginationInfo
     */
    'current_page': number;
    /**
     * 合計のページ
     * @type {number}
     * @memberof PaginationInfo
     */
    'total_pages': number;
    /**
     * 合計数
     * @type {number}
     * @memberof PaginationInfo
     */
    'total_count': number;
}
/**
 * 権限データ
 * @export
 * @interface Permission
 */
export interface Permission {
    /**
     * 権限ID
     * @type {number}
     * @memberof Permission
     */
    'id': number;
    /**
     * 権限名
     * @type {string}
     * @memberof Permission
     */
    'basename': string;
    /**
     * 表示名
     * @type {string}
     * @memberof Permission
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PostMessageData200Response
 */
export interface PostMessageData200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof PostMessageData200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {PostMessageData200ResponsePayload}
     * @memberof PostMessageData200Response
     */
    'payload': PostMessageData200ResponsePayload;
}
/**
 * 
 * @export
 * @interface PostMessageData200ResponsePayload
 */
export interface PostMessageData200ResponsePayload {
    /**
     * 
     * @type {Message}
     * @memberof PostMessageData200ResponsePayload
     */
    'message': Message;
}
/**
 * 
 * @export
 * @interface PostMessageDataRequest
 */
export interface PostMessageDataRequest {
    /**
     * メッセージ作成データ
     * @type {CreateMessage}
     * @memberof PostMessageDataRequest
     */
    'message': CreateMessage;
}
/**
 * 
 * @export
 * @interface PostNewsData200Response
 */
export interface PostNewsData200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof PostNewsData200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {PostNewsData200ResponsePayload}
     * @memberof PostNewsData200Response
     */
    'payload': PostNewsData200ResponsePayload;
}
/**
 * 
 * @export
 * @interface PostNewsData200ResponsePayload
 */
export interface PostNewsData200ResponsePayload {
    /**
     * お知らせID
     * @type {number}
     * @memberof PostNewsData200ResponsePayload
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface PostPasswordResetRequest
 */
export interface PostPasswordResetRequest {
    /**
     * 認証コード
     * @type {string}
     * @memberof PostPasswordResetRequest
     */
    'code': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof PostPasswordResetRequest
     */
    'email': string;
    /**
     * パスワード
     * @type {string}
     * @memberof PostPasswordResetRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface PostPasswordResetRequestRequest
 */
export interface PostPasswordResetRequestRequest {
    /**
     * メールアドレス
     * @type {string}
     * @memberof PostPasswordResetRequestRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface PostSession200Response
 */
export interface PostSession200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof PostSession200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {PostSession200ResponsePayload}
     * @memberof PostSession200Response
     */
    'payload': PostSession200ResponsePayload;
}
/**
 * 
 * @export
 * @interface PostSession200ResponsePayload
 */
export interface PostSession200ResponsePayload {
    /**
     * 
     * @type {User}
     * @memberof PostSession200ResponsePayload
     */
    'user'?: User;
    /**
     * 権限データ
     * @type {Array<Permission>}
     * @memberof PostSession200ResponsePayload
     */
    'permissions'?: Array<Permission>;
    /**
     * パスワード変更フラグ
     * @type {boolean}
     * @memberof PostSession200ResponsePayload
     */
    'require_reset_password'?: boolean;
    /**
     * パスワード変更コード
     * @type {string}
     * @memberof PostSession200ResponsePayload
     */
    'code'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof PostSession200ResponsePayload
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface PostSessionRequest
 */
export interface PostSessionRequest {
    /**
     * メールアドレス
     * @type {string}
     * @memberof PostSessionRequest
     */
    'email': string;
    /**
     * パスワード
     * @type {string}
     * @memberof PostSessionRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface PostSettingData200Response
 */
export interface PostSettingData200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof PostSettingData200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {PostSettingData200ResponsePayload}
     * @memberof PostSettingData200Response
     */
    'payload': PostSettingData200ResponsePayload;
}
/**
 * 
 * @export
 * @interface PostSettingData200ResponsePayload
 */
export interface PostSettingData200ResponsePayload {
    /**
     * 設定ID
     * @type {number}
     * @memberof PostSettingData200ResponsePayload
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface PostSettingDataRequest
 */
export interface PostSettingDataRequest {
    /**
     * 設定作成・更新データ
     * @type {UpdateJskAccidentLocationSetting}
     * @memberof PostSettingDataRequest
     */
    'setting': UpdateJskAccidentLocationSetting;
}
/**
 * 
 * @export
 * @interface PostVendorData200Response
 */
export interface PostVendorData200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof PostVendorData200Response
     */
    'info': ResponseInfo;
    /**
     * 
     * @type {PostVendorData200ResponsePayload}
     * @memberof PostVendorData200Response
     */
    'payload': PostVendorData200ResponsePayload;
}
/**
 * 
 * @export
 * @interface PostVendorData200ResponsePayload
 */
export interface PostVendorData200ResponsePayload {
    /**
     * 加盟店ID
     * @type {number}
     * @memberof PostVendorData200ResponsePayload
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface PutMessageReadRequest
 */
export interface PutMessageReadRequest {
    /**
     * 加盟店ID
     * @type {number}
     * @memberof PutMessageReadRequest
     */
    'vendor_id': number;
    /**
     * メッセージID
     * @type {number}
     * @memberof PutMessageReadRequest
     */
    'message_id': number;
}
/**
 * 
 * @export
 * @interface PutNewsData200Response
 */
export interface PutNewsData200Response {
    /**
     * 
     * @type {ResponseInfo}
     * @memberof PutNewsData200Response
     */
    'info': ResponseInfo;
}
/**
 * 
 * @export
 * @interface PutNewsDataRequest
 */
export interface PutNewsDataRequest {
    /**
     * お知らせ作成・更新データ
     * @type {UpdateNews}
     * @memberof PutNewsDataRequest
     */
    'news': UpdateNews;
}
/**
 * 
 * @export
 * @interface PutVendorDataRequest
 */
export interface PutVendorDataRequest {
    /**
     * 加盟店作成・更新データ
     * @type {UpdateVendor}
     * @memberof PutVendorDataRequest
     */
    'vendor': UpdateVendor;
}
/**
 * レスポンスデータ
 * @export
 * @interface ResponseInfo
 */
export interface ResponseInfo {
    /**
     * ステータス
     * @type {string}
     * @memberof ResponseInfo
     */
    'status': ResponseInfoStatusEnum;
    /**
     * メッセージ
     * @type {string}
     * @memberof ResponseInfo
     */
    'message'?: string;
}

export const ResponseInfoStatusEnum = {
    Ok: 'ok',
    Err: 'err'
} as const;

export type ResponseInfoStatusEnum = typeof ResponseInfoStatusEnum[keyof typeof ResponseInfoStatusEnum];

/**
 * 損害サービス・箇所設定データ
 * @export
 * @interface UpdateJskAccidentLocationSetting
 */
export interface UpdateJskAccidentLocationSetting {
    /**
     * 事故種別名
     * @type {string}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'name': string;
    /**
     * 選択可能期間
     * @type {number}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'select_year': number;
    /**
     * 事故箇所1選択フラグ
     * @type {number}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_location_select_flag1': number;
    /**
     * 事故箇所1設定数
     * @type {string}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_location_select_count1': string;
    /**
     * 事故箇所2選択フラグ
     * @type {number}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_location_select_flag2': number;
    /**
     * 事故箇所2設定数
     * @type {string}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_location_select_count2': string;
    /**
     * 事故箇所3選択フラグ
     * @type {number}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_location_select_flag3': number;
    /**
     * 事故箇所3設定数
     * @type {string}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_location_select_count3': string;
    /**
     * 事故部位1選択フラグ
     * @type {number}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_part_select_flag1': number;
    /**
     * 事故部位1設定数
     * @type {string}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_part_select_count1': string;
    /**
     * 事故部位2選択フラグ
     * @type {number}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_part_select_flag2': number;
    /**
     * 事故部位2設定数
     * @type {string}
     * @memberof UpdateJskAccidentLocationSetting
     */
    'accident_part_select_count2': string;
}
/**
 * お知らせ作成・更新データ
 * @export
 * @interface UpdateNews
 */
export interface UpdateNews {
    /**
     * タイトル
     * @type {string}
     * @memberof UpdateNews
     */
    'title': string;
    /**
     * 本文
     * @type {string}
     * @memberof UpdateNews
     */
    'body': string;
    /**
     * 公開日時
     * @type {string}
     * @memberof UpdateNews
     */
    'publish_date': string;
}
/**
 * ユーザー更新データ
 * @export
 * @interface UpdateUser
 */
export interface UpdateUser {
    /**
     * ユーザID
     * @type {number}
     * @memberof UpdateUser
     */
    'id': number;
    /**
     * 名前
     * @type {string}
     * @memberof UpdateUser
     */
    'name': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof UpdateUser
     */
    'email': string;
    /**
     * 削除フラグ
     * @type {number}
     * @memberof UpdateUser
     */
    'deleted_flag': number;
    /**
     * 加盟店ID
     * @type {number}
     * @memberof UpdateUser
     */
    'jsk_vendor_id'?: number;
    /**
     * メールアドレス(暗号化)
     * @type {string}
     * @memberof UpdateUser
     */
    'email_encrypted'?: string;
}
/**
 * 加盟店作成・更新データ
 * @export
 * @interface UpdateVendor
 */
export interface UpdateVendor {
    /**
     * ステータスID
     * @type {number}
     * @memberof UpdateVendor
     */
    'jsk_mst_vendor_statuse_id': number;
    /**
     * メールアドレス
     * @type {string}
     * @memberof UpdateVendor
     */
    'email'?: string;
    /**
     * 法人名
     * @type {string}
     * @memberof UpdateVendor
     */
    'name': string;
    /**
     * 法人名(フリガナ)
     * @type {string}
     * @memberof UpdateVendor
     */
    'name_kana': string;
    /**
     * 代表者名
     * @type {string}
     * @memberof UpdateVendor
     */
    'person': string;
    /**
     * 代表者名(フリガナ)
     * @type {string}
     * @memberof UpdateVendor
     */
    'person_kana': string;
    /**
     * 郵便番号1
     * @type {string}
     * @memberof UpdateVendor
     */
    'zip1': string;
    /**
     * 郵便番号2
     * @type {string}
     * @memberof UpdateVendor
     */
    'zip2': string;
    /**
     * 都道府県ID
     * @type {number}
     * @memberof UpdateVendor
     */
    'address_prefecture_id': number;
    /**
     * 市町村区
     * @type {string}
     * @memberof UpdateVendor
     */
    'address1': string;
    /**
     * 町名・番地
     * @type {string}
     * @memberof UpdateVendor
     */
    'address2': string;
    /**
     * 電話番号1
     * @type {string}
     * @memberof UpdateVendor
     */
    'tel1': string;
    /**
     * 電話番号2
     * @type {string}
     * @memberof UpdateVendor
     */
    'tel2': string;
    /**
     * 電話番号3
     * @type {string}
     * @memberof UpdateVendor
     */
    'tel3': string;
    /**
     * FAX1
     * @type {string}
     * @memberof UpdateVendor
     */
    'fax1': string;
    /**
     * FAX2
     * @type {string}
     * @memberof UpdateVendor
     */
    'fax2': string;
    /**
     * FAX3
     * @type {string}
     * @memberof UpdateVendor
     */
    'fax3': string;
    /**
     * 郵便番号1(請求情報)
     * @type {string}
     * @memberof UpdateVendor
     */
    'bill_address_zip1': string;
    /**
     * 郵便番号2(請求情報)
     * @type {string}
     * @memberof UpdateVendor
     */
    'bill_address_zip2': string;
    /**
     * 都道府県ID(請求情報)
     * @type {number}
     * @memberof UpdateVendor
     */
    'bill_address_prefecture_id': number;
    /**
     * 市町村区(請求情報)
     * @type {string}
     * @memberof UpdateVendor
     */
    'bill_address_address1': string;
    /**
     * 町名・番地(請求情報)
     * @type {string}
     * @memberof UpdateVendor
     */
    'bill_address_address2': string;
    /**
     * 設立年
     * @type {number}
     * @memberof UpdateVendor
     */
    'establishment_year': number;
    /**
     * 設立月
     * @type {number}
     * @memberof UpdateVendor
     */
    'establishment_month': number;
    /**
     * 設立日
     * @type {number}
     * @memberof UpdateVendor
     */
    'establishment_date': number;
    /**
     * 決算月
     * @type {number}
     * @memberof UpdateVendor
     */
    'account_closing_month': number;
    /**
     * メールアドレス(暗号化)
     * @type {string}
     * @memberof UpdateVendor
     */
    'email_encrypted'?: string;
    /**
     * メールアドレス(ハッシュ化)
     * @type {string}
     * @memberof UpdateVendor
     */
    'email_hashed'?: string;
}
/**
 * 
 * @export
 * @interface UpdateVendorWithoutEmail
 */
export interface UpdateVendorWithoutEmail {
    /**
     * ステータスID
     * @type {number}
     * @memberof UpdateVendorWithoutEmail
     */
    'jsk_mst_vendor_statuse_id': number;
    /**
     * 法人名
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'name': string;
    /**
     * 法人名(フリガナ)
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'name_kana': string;
    /**
     * 代表者名
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'person': string;
    /**
     * 代表者名(フリガナ)
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'person_kana': string;
    /**
     * 郵便番号1
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'zip1': string;
    /**
     * 郵便番号2
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'zip2': string;
    /**
     * 都道府県ID
     * @type {number}
     * @memberof UpdateVendorWithoutEmail
     */
    'address_prefecture_id': number;
    /**
     * 市町村区
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'address1': string;
    /**
     * 町名・番地
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'address2': string;
    /**
     * 電話番号1
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'tel1': string;
    /**
     * 電話番号2
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'tel2': string;
    /**
     * 電話番号3
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'tel3': string;
    /**
     * FAX1
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'fax1': string;
    /**
     * FAX2
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'fax2': string;
    /**
     * FAX3
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'fax3': string;
    /**
     * 郵便番号1(請求情報)
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'bill_address_zip1': string;
    /**
     * 郵便番号2(請求情報)
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'bill_address_zip2': string;
    /**
     * 都道府県ID(請求情報)
     * @type {number}
     * @memberof UpdateVendorWithoutEmail
     */
    'bill_address_prefecture_id': number;
    /**
     * 市町村区(請求情報)
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'bill_address_address1': string;
    /**
     * 町名・番地(請求情報)
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'bill_address_address2': string;
    /**
     * 設立年
     * @type {number}
     * @memberof UpdateVendorWithoutEmail
     */
    'establishment_year': number;
    /**
     * 設立月
     * @type {number}
     * @memberof UpdateVendorWithoutEmail
     */
    'establishment_month': number;
    /**
     * 設立日
     * @type {number}
     * @memberof UpdateVendorWithoutEmail
     */
    'establishment_date': number;
    /**
     * 決算月
     * @type {number}
     * @memberof UpdateVendorWithoutEmail
     */
    'account_closing_month': number;
    /**
     * メールアドレス(暗号化)
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'email_encrypted'?: string;
    /**
     * メールアドレス(ハッシュ化)
     * @type {string}
     * @memberof UpdateVendorWithoutEmail
     */
    'email_hashed'?: string;
}
/**
 * ユーザーデータ
 * @export
 * @interface User
 */
export interface User {
    /**
     * ユーザID
     * @type {number}
     * @memberof User
     */
    'id': number;
    /**
     * 名前
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof User
     */
    'email': string;
    /**
     * 削除フラグ
     * @type {number}
     * @memberof User
     */
    'deleted_flag': number;
    /**
     * 加盟店ID
     * @type {number}
     * @memberof User
     */
    'jsk_vendor_id'?: number;
    /**
     * 作成日時
     * @type {string}
     * @memberof User
     */
    'created': string;
    /**
     * 更新日時
     * @type {string}
     * @memberof User
     */
    'modified': string;
    /**
     * メールアドレス(暗号化)
     * @type {string}
     * @memberof User
     */
    'email_encrypted'?: string;
}
/**
 * 加盟店データ
 * @export
 * @interface Vendor
 */
export interface Vendor {
    /**
     * 加盟店ID
     * @type {number}
     * @memberof Vendor
     */
    'id': number;
    /**
     * ステータスID
     * @type {number}
     * @memberof Vendor
     */
    'jsk_mst_vendor_statuse_id': number;
    /**
     * メールアドレス
     * @type {string}
     * @memberof Vendor
     */
    'email'?: string;
    /**
     * 法人名
     * @type {string}
     * @memberof Vendor
     */
    'name': string;
    /**
     * 法人名(フリガナ)
     * @type {string}
     * @memberof Vendor
     */
    'name_kana': string;
    /**
     * 代表者名
     * @type {string}
     * @memberof Vendor
     */
    'person': string;
    /**
     * 代表者名(フリガナ)
     * @type {string}
     * @memberof Vendor
     */
    'person_kana': string;
    /**
     * 郵便番号1
     * @type {string}
     * @memberof Vendor
     */
    'zip1': string;
    /**
     * 郵便番号2
     * @type {string}
     * @memberof Vendor
     */
    'zip2': string;
    /**
     * 都道府県ID
     * @type {number}
     * @memberof Vendor
     */
    'address_prefecture_id': number;
    /**
     * 市町村区
     * @type {string}
     * @memberof Vendor
     */
    'address1': string;
    /**
     * 町名・番地
     * @type {string}
     * @memberof Vendor
     */
    'address2': string;
    /**
     * 電話番号1
     * @type {string}
     * @memberof Vendor
     */
    'tel1': string;
    /**
     * 電話番号2
     * @type {string}
     * @memberof Vendor
     */
    'tel2': string;
    /**
     * 電話番号3
     * @type {string}
     * @memberof Vendor
     */
    'tel3': string;
    /**
     * FAX1
     * @type {string}
     * @memberof Vendor
     */
    'fax1': string;
    /**
     * FAX2
     * @type {string}
     * @memberof Vendor
     */
    'fax2': string;
    /**
     * FAX3
     * @type {string}
     * @memberof Vendor
     */
    'fax3': string;
    /**
     * 郵便番号1(請求情報)
     * @type {string}
     * @memberof Vendor
     */
    'bill_address_zip1': string;
    /**
     * 郵便番号2(請求情報)
     * @type {string}
     * @memberof Vendor
     */
    'bill_address_zip2': string;
    /**
     * 都道府県ID(請求情報)
     * @type {number}
     * @memberof Vendor
     */
    'bill_address_prefecture_id': number;
    /**
     * 市町村区(請求情報)
     * @type {string}
     * @memberof Vendor
     */
    'bill_address_address1': string;
    /**
     * 町名・番地(請求情報)
     * @type {string}
     * @memberof Vendor
     */
    'bill_address_address2': string;
    /**
     * 設立年
     * @type {number}
     * @memberof Vendor
     */
    'establishment_year': number;
    /**
     * 設立月
     * @type {number}
     * @memberof Vendor
     */
    'establishment_month': number;
    /**
     * 設立日
     * @type {number}
     * @memberof Vendor
     */
    'establishment_date': number;
    /**
     * 決算月
     * @type {number}
     * @memberof Vendor
     */
    'account_closing_month': number;
    /**
     * メールアドレス(暗号化)
     * @type {string}
     * @memberof Vendor
     */
    'email_encrypted'?: string;
    /**
     * 都道府県
     * @type {string}
     * @memberof Vendor
     */
    'address_prefecture'?: string;
    /**
     * 保証物件数
     * @type {number}
     * @memberof Vendor
     */
    'guaranteed_property_count'?: number;
    /**
     * 保証金額
     * @type {number}
     * @memberof Vendor
     */
    'guaranteed_amount'?: number;
    /**
     * 保険料(原価)
     * @type {number}
     * @memberof Vendor
     */
    'insurance_cost'?: number;
    /**
     * 支払金額
     * @type {number}
     * @memberof Vendor
     */
    'payment_amount'?: number;
    /**
     * 作成日時
     * @type {string}
     * @memberof Vendor
     */
    'created': string;
    /**
     * 更新日時
     * @type {string}
     * @memberof Vendor
     */
    'modified': string;
}
/**
 * 加盟店簡易データ
 * @export
 * @interface VendorForCollection
 */
export interface VendorForCollection {
    /**
     * 加盟店ID
     * @type {number}
     * @memberof VendorForCollection
     */
    'id': number;
    /**
     * 法人名
     * @type {string}
     * @memberof VendorForCollection
     */
    'name': string;
    /**
     * 都道府県ID
     * @type {number}
     * @memberof VendorForCollection
     */
    'address_prefecture_id': number;
    /**
     * 都道府県
     * @type {string}
     * @memberof VendorForCollection
     */
    'address_prefecture'?: string;
    /**
     * 保証物件数
     * @type {number}
     * @memberof VendorForCollection
     */
    'guaranteed_property_count'?: number;
    /**
     * 保証金額
     * @type {number}
     * @memberof VendorForCollection
     */
    'guaranteed_amount'?: number;
    /**
     * 保険料(原価)
     * @type {number}
     * @memberof VendorForCollection
     */
    'insurance_cost'?: number;
    /**
     * 支払金額
     * @type {number}
     * @memberof VendorForCollection
     */
    'payment_amount'?: number;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary メッセージ 削除
         * @param {number} messageId メッセージID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessageData: async (messageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('deleteMessageData', 'messageId', messageId)
            const localVarPath = `/message/{message_id}/data`
                .replace(`{${"message_id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary お知らせ 削除
         * @param {number} newsId お知らせID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNewsData: async (newsId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('deleteNewsData', 'newsId', newsId)
            const localVarPath = `/news/{news_id}/data`
                .replace(`{${"news_id"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSession: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加盟店 削除
         * @param {number} vendorId 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorData: async (vendorId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('deleteVendorData', 'vendorId', vendorId)
            const localVarPath = `/vendor/{vendor_id}/data`
                .replace(`{${"vendor_id"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CSV 取得
         * @param {string} [name] 加盟店名
         * @param {number} [addressPrefectureId] 都道府県ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportVendor: async (name?: string, addressPrefectureId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vendor/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (addressPrefectureId !== undefined) {
                localVarQueryParameter['address_prefecture_id'] = addressPrefectureId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary CSRFトークン 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsrf: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/csrf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ファイル URL 取得
         * @param {string} [path] パス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile: async (path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/file/index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ファイル アップロードURL 取得
         * @param {string} [name] ファイル名
         * @param {string} [contentType] コンテンツタイプ
         * @param {number} [size] サイズ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileUploadRequest: async (name?: string, contentType?: string, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/file/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (contentType !== undefined) {
                localVarQueryParameter['content_type'] = contentType;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 設定一覧 取得
         * @param {string} [name] 事故種別名
         * @param {number} [selectYear] 選択可能期間年数
         * @param {string} [accidentLocation] 事故箇所
         * @param {string} [accidentPart] 事故部分
         * @param {number} [page] ページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJskAccidentLocationSettingCollection: async (name?: string, selectYear?: number, accidentLocation?: string, accidentPart?: string, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setting/index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (selectYear !== undefined) {
                localVarQueryParameter['select_year'] = selectYear;
            }

            if (accidentLocation !== undefined) {
                localVarQueryParameter['accident_location'] = accidentLocation;
            }

            if (accidentPart !== undefined) {
                localVarQueryParameter['accident_part'] = accidentPart;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メッセージ一覧 取得
         * @param {number} vendorId 加盟店ID
         * @param {number} [offset] 開始
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageCollection: async (vendorId: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('getMessageCollection', 'vendorId', vendorId)
            const localVarPath = `/message/{vendor_id}/index`
                .replace(`{${"vendor_id"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メッセージ 取得
         * @param {number} vendorId 加盟店ID
         * @param {number} [messageId] メッセージID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageData: async (vendorId: number, messageId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('getMessageData', 'vendorId', vendorId)
            const localVarPath = `/message/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vendorId !== undefined) {
                localVarQueryParameter['vendor_id'] = vendorId;
            }

            if (messageId !== undefined) {
                localVarQueryParameter['message_id'] = messageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary お知らせ一覧 取得
         * @param {number} [page] ページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsCollection: async (page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/news/index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary お知らせ 取得
         * @param {number} newsId お知らせID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsData: async (newsId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('getNewsData', 'newsId', newsId)
            const localVarPath = `/news/{news_id}/data`
                .replace(`{${"news_id"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 通知 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 宛先 選択肢 取得
         * @param {number} [vendorId] 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptionDestination: async (vendorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/option/destination`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vendorId !== undefined) {
                localVarQueryParameter['vendor_id'] = vendorId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 都道府県 選択肢 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptionPrefecture: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/option/prefecture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary セッション 取得
         * @param {string} [xCSRFTOKEN] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession: async (xCSRFTOKEN?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCSRFTOKEN != null) {
                localVarHeaderParameter['X-CSRF-TOKEN'] = String(xCSRFTOKEN);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加盟店一覧 取得
         * @param {string} [name] 加盟店名
         * @param {number} [addressPrefectureId] 都道府県ID
         * @param {number} [page] ページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorCollection: async (name?: string, addressPrefectureId?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vendor/index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (addressPrefectureId !== undefined) {
                localVarQueryParameter['address_prefecture_id'] = addressPrefectureId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加盟店 取得
         * @param {number} vendorId 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorData: async (vendorId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('getVendorData', 'vendorId', vendorId)
            const localVarPath = `/vendor/{vendor_id}/data`
                .replace(`{${"vendor_id"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加盟店 メンバー 取得
         * @param {number} vendorId 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorMember: async (vendorId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('getVendorMember', 'vendorId', vendorId)
            const localVarPath = `/vendor/{vendor_id}/member`
                .replace(`{${"vendor_id"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  メッセージ 作成
         * @param {PostMessageDataRequest} [postMessageDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessageData: async (postMessageDataRequest?: PostMessageDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/message/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postMessageDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary お知らせ 作成
         * @param {PutNewsDataRequest} [putNewsDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewsData: async (putNewsDataRequest?: PutNewsDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/news/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putNewsDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パスワード リセット
         * @param {PostPasswordResetRequest} [postPasswordResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPasswordReset: async (postPasswordResetRequest?: PostPasswordResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPasswordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パスワード リセット リクエスト
         * @param {PostPasswordResetRequestRequest} [postPasswordResetRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPasswordResetRequest: async (postPasswordResetRequestRequest?: PostPasswordResetRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/password/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPasswordResetRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログイン
         * @param {PostSessionRequest} [postSessionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSession: async (postSessionRequest?: PostSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 設定 作成
         * @param {PostSettingDataRequest} [postSettingDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSettingData: async (postSettingDataRequest?: PostSettingDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setting/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSettingDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加盟店 作成
         * @param {PutVendorDataRequest} [putVendorDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVendorData: async (putVendorDataRequest?: PutVendorDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vendor/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putVendorDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary  メッセージ 既読
         * @param {PutMessageReadRequest} [putMessageReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMessageRead: async (putMessageReadRequest?: PutMessageReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/message/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putMessageReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary お知らせ 更新
         * @param {number} newsId お知らせID
         * @param {PutNewsDataRequest} [putNewsDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putNewsData: async (newsId: number, putNewsDataRequest?: PutNewsDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('putNewsData', 'newsId', newsId)
            const localVarPath = `/news/{news_id}/data`
                .replace(`{${"news_id"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putNewsDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 設定 更新
         * @param {number} settingId 事故種別ID
         * @param {PostSettingDataRequest} [postSettingDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSettingData: async (settingId: number, postSettingDataRequest?: PostSettingDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settingId' is not null or undefined
            assertParamExists('putSettingData', 'settingId', settingId)
            const localVarPath = `/setting/{setting_id}/data`
                .replace(`{${"setting_id"}}`, encodeURIComponent(String(settingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSettingDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 加盟店 更新
         * @param {number} vendorId 加盟店ID
         * @param {PutVendorDataRequest} [putVendorDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVendorData: async (vendorId: number, putVendorDataRequest?: PutVendorDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('putVendorData', 'vendorId', vendorId)
            const localVarPath = `/vendor/{vendor_id}/data`
                .replace(`{${"vendor_id"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putVendorDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary メッセージ 削除
         * @param {number} messageId メッセージID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMessageData(messageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMessageData(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteMessageData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary お知らせ 削除
         * @param {number} newsId お知らせID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNewsData(newsId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNewsData(newsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteNewsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSession(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSession(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加盟店 削除
         * @param {number} vendorId 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVendorData(vendorId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVendorData(vendorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteVendorData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary CSV 取得
         * @param {string} [name] 加盟店名
         * @param {number} [addressPrefectureId] 都道府県ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportVendor(name?: string, addressPrefectureId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportVendor200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportVendor(name, addressPrefectureId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.exportVendor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary CSRFトークン 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCsrf(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCsrf200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCsrf(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCsrf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ファイル URL 取得
         * @param {string} [path] パス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFile(path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFile(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ファイル アップロードURL 取得
         * @param {string} [name] ファイル名
         * @param {string} [contentType] コンテンツタイプ
         * @param {number} [size] サイズ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileUploadRequest(name?: string, contentType?: string, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFileUploadRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileUploadRequest(name, contentType, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFileUploadRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 設定一覧 取得
         * @param {string} [name] 事故種別名
         * @param {number} [selectYear] 選択可能期間年数
         * @param {string} [accidentLocation] 事故箇所
         * @param {string} [accidentPart] 事故部分
         * @param {number} [page] ページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJskAccidentLocationSettingCollection(name?: string, selectYear?: number, accidentLocation?: string, accidentPart?: string, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJskAccidentLocationSettingCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJskAccidentLocationSettingCollection(name, selectYear, accidentLocation, accidentPart, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getJskAccidentLocationSettingCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary メッセージ一覧 取得
         * @param {number} vendorId 加盟店ID
         * @param {number} [offset] 開始
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageCollection(vendorId: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMessageCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageCollection(vendorId, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMessageCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary メッセージ 取得
         * @param {number} vendorId 加盟店ID
         * @param {number} [messageId] メッセージID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageData(vendorId: number, messageId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMessageData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageData(vendorId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMessageData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary お知らせ一覧 取得
         * @param {number} [page] ページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsCollection(page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNewsCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsCollection(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getNewsCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary お知らせ 取得
         * @param {number} newsId お知らせID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsData(newsId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsData(newsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getNewsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 通知 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotification(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNotification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotification(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 宛先 選択肢 取得
         * @param {number} [vendorId] 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOptionDestination(vendorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOptionPrefecture200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOptionDestination(vendorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOptionDestination']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 都道府県 選択肢 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOptionPrefecture(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOptionPrefecture200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOptionPrefecture(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOptionPrefecture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary セッション 取得
         * @param {string} [xCSRFTOKEN] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSession(xCSRFTOKEN?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSession(xCSRFTOKEN, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加盟店一覧 取得
         * @param {string} [name] 加盟店名
         * @param {number} [addressPrefectureId] 都道府県ID
         * @param {number} [page] ページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVendorCollection(name?: string, addressPrefectureId?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVendorCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVendorCollection(name, addressPrefectureId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getVendorCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加盟店 取得
         * @param {number} vendorId 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVendorData(vendorId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVendorData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVendorData(vendorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getVendorData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加盟店 メンバー 取得
         * @param {number} vendorId 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVendorMember(vendorId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVendorMember200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVendorMember(vendorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getVendorMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary  メッセージ 作成
         * @param {PostMessageDataRequest} [postMessageDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMessageData(postMessageDataRequest?: PostMessageDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostMessageData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMessageData(postMessageDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postMessageData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary お知らせ 作成
         * @param {PutNewsDataRequest} [putNewsDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNewsData(putNewsDataRequest?: PutNewsDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNewsData(putNewsDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postNewsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary パスワード リセット
         * @param {PostPasswordResetRequest} [postPasswordResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPasswordReset(postPasswordResetRequest?: PostPasswordResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPasswordReset(postPasswordResetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary パスワード リセット リクエスト
         * @param {PostPasswordResetRequestRequest} [postPasswordResetRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPasswordResetRequest(postPasswordResetRequestRequest?: PostPasswordResetRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPasswordResetRequest(postPasswordResetRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postPasswordResetRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ログイン
         * @param {PostSessionRequest} [postSessionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSession(postSessionRequest?: PostSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSession(postSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 設定 作成
         * @param {PostSettingDataRequest} [postSettingDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSettingData(postSettingDataRequest?: PostSettingDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSettingData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSettingData(postSettingDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postSettingData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加盟店 作成
         * @param {PutVendorDataRequest} [putVendorDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postVendorData(putVendorDataRequest?: PutVendorDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostVendorData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postVendorData(putVendorDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.postVendorData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary  メッセージ 既読
         * @param {PutMessageReadRequest} [putMessageReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putMessageRead(putMessageReadRequest?: PutMessageReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putMessageRead(putMessageReadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putMessageRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary お知らせ 更新
         * @param {number} newsId お知らせID
         * @param {PutNewsDataRequest} [putNewsDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putNewsData(newsId: number, putNewsDataRequest?: PutNewsDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putNewsData(newsId, putNewsDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putNewsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 設定 更新
         * @param {number} settingId 事故種別ID
         * @param {PostSettingDataRequest} [postSettingDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSettingData(settingId: number, postSettingDataRequest?: PostSettingDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSettingData(settingId, postSettingDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putSettingData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 加盟店 更新
         * @param {number} vendorId 加盟店ID
         * @param {PutVendorDataRequest} [putVendorDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVendorData(vendorId: number, putVendorDataRequest?: PutVendorDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutNewsData200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVendorData(vendorId, putVendorDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.putVendorData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary メッセージ 削除
         * @param {number} messageId メッセージID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessageData(messageId: number, options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.deleteMessageData(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary お知らせ 削除
         * @param {number} newsId お知らせID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNewsData(newsId: number, options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.deleteNewsData(newsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSession(options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.deleteSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加盟店 削除
         * @param {number} vendorId 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVendorData(vendorId: number, options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.deleteVendorData(vendorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CSV 取得
         * @param {string} [name] 加盟店名
         * @param {number} [addressPrefectureId] 都道府県ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportVendor(name?: string, addressPrefectureId?: number, options?: any): AxiosPromise<ExportVendor200Response> {
            return localVarFp.exportVendor(name, addressPrefectureId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary CSRFトークン 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsrf(options?: any): AxiosPromise<GetCsrf200Response> {
            return localVarFp.getCsrf(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ファイル URL 取得
         * @param {string} [path] パス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile(path?: string, options?: any): AxiosPromise<GetFile200Response> {
            return localVarFp.getFile(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ファイル アップロードURL 取得
         * @param {string} [name] ファイル名
         * @param {string} [contentType] コンテンツタイプ
         * @param {number} [size] サイズ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileUploadRequest(name?: string, contentType?: string, size?: number, options?: any): AxiosPromise<GetFileUploadRequest200Response> {
            return localVarFp.getFileUploadRequest(name, contentType, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 設定一覧 取得
         * @param {string} [name] 事故種別名
         * @param {number} [selectYear] 選択可能期間年数
         * @param {string} [accidentLocation] 事故箇所
         * @param {string} [accidentPart] 事故部分
         * @param {number} [page] ページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJskAccidentLocationSettingCollection(name?: string, selectYear?: number, accidentLocation?: string, accidentPart?: string, page?: number, options?: any): AxiosPromise<GetJskAccidentLocationSettingCollection200Response> {
            return localVarFp.getJskAccidentLocationSettingCollection(name, selectYear, accidentLocation, accidentPart, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メッセージ一覧 取得
         * @param {number} vendorId 加盟店ID
         * @param {number} [offset] 開始
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageCollection(vendorId: number, offset?: number, options?: any): AxiosPromise<GetMessageCollection200Response> {
            return localVarFp.getMessageCollection(vendorId, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メッセージ 取得
         * @param {number} vendorId 加盟店ID
         * @param {number} [messageId] メッセージID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageData(vendorId: number, messageId?: number, options?: any): AxiosPromise<GetMessageData200Response> {
            return localVarFp.getMessageData(vendorId, messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary お知らせ一覧 取得
         * @param {number} [page] ページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsCollection(page?: number, options?: any): AxiosPromise<GetNewsCollection200Response> {
            return localVarFp.getNewsCollection(page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary お知らせ 取得
         * @param {number} newsId お知らせID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsData(newsId: number, options?: any): AxiosPromise<GetNewsData200Response> {
            return localVarFp.getNewsData(newsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 通知 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(options?: any): AxiosPromise<GetNotification200Response> {
            return localVarFp.getNotification(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 宛先 選択肢 取得
         * @param {number} [vendorId] 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptionDestination(vendorId?: number, options?: any): AxiosPromise<GetOptionPrefecture200Response> {
            return localVarFp.getOptionDestination(vendorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 都道府県 選択肢 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOptionPrefecture(options?: any): AxiosPromise<GetOptionPrefecture200Response> {
            return localVarFp.getOptionPrefecture(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary セッション 取得
         * @param {string} [xCSRFTOKEN] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSession(xCSRFTOKEN?: string, options?: any): AxiosPromise<GetSession200Response> {
            return localVarFp.getSession(xCSRFTOKEN, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加盟店一覧 取得
         * @param {string} [name] 加盟店名
         * @param {number} [addressPrefectureId] 都道府県ID
         * @param {number} [page] ページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorCollection(name?: string, addressPrefectureId?: number, page?: number, options?: any): AxiosPromise<GetVendorCollection200Response> {
            return localVarFp.getVendorCollection(name, addressPrefectureId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加盟店 取得
         * @param {number} vendorId 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorData(vendorId: number, options?: any): AxiosPromise<GetVendorData200Response> {
            return localVarFp.getVendorData(vendorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加盟店 メンバー 取得
         * @param {number} vendorId 加盟店ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorMember(vendorId: number, options?: any): AxiosPromise<GetVendorMember200Response> {
            return localVarFp.getVendorMember(vendorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  メッセージ 作成
         * @param {PostMessageDataRequest} [postMessageDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessageData(postMessageDataRequest?: PostMessageDataRequest, options?: any): AxiosPromise<PostMessageData200Response> {
            return localVarFp.postMessageData(postMessageDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary お知らせ 作成
         * @param {PutNewsDataRequest} [putNewsDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewsData(putNewsDataRequest?: PutNewsDataRequest, options?: any): AxiosPromise<PostNewsData200Response> {
            return localVarFp.postNewsData(putNewsDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パスワード リセット
         * @param {PostPasswordResetRequest} [postPasswordResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPasswordReset(postPasswordResetRequest?: PostPasswordResetRequest, options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.postPasswordReset(postPasswordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パスワード リセット リクエスト
         * @param {PostPasswordResetRequestRequest} [postPasswordResetRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPasswordResetRequest(postPasswordResetRequestRequest?: PostPasswordResetRequestRequest, options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.postPasswordResetRequest(postPasswordResetRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ログイン
         * @param {PostSessionRequest} [postSessionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSession(postSessionRequest?: PostSessionRequest, options?: any): AxiosPromise<PostSession200Response> {
            return localVarFp.postSession(postSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 設定 作成
         * @param {PostSettingDataRequest} [postSettingDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSettingData(postSettingDataRequest?: PostSettingDataRequest, options?: any): AxiosPromise<PostSettingData200Response> {
            return localVarFp.postSettingData(postSettingDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加盟店 作成
         * @param {PutVendorDataRequest} [putVendorDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVendorData(putVendorDataRequest?: PutVendorDataRequest, options?: any): AxiosPromise<PostVendorData200Response> {
            return localVarFp.postVendorData(putVendorDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary  メッセージ 既読
         * @param {PutMessageReadRequest} [putMessageReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMessageRead(putMessageReadRequest?: PutMessageReadRequest, options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.putMessageRead(putMessageReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary お知らせ 更新
         * @param {number} newsId お知らせID
         * @param {PutNewsDataRequest} [putNewsDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putNewsData(newsId: number, putNewsDataRequest?: PutNewsDataRequest, options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.putNewsData(newsId, putNewsDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 設定 更新
         * @param {number} settingId 事故種別ID
         * @param {PostSettingDataRequest} [postSettingDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSettingData(settingId: number, postSettingDataRequest?: PostSettingDataRequest, options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.putSettingData(settingId, postSettingDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 加盟店 更新
         * @param {number} vendorId 加盟店ID
         * @param {PutVendorDataRequest} [putVendorDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVendorData(vendorId: number, putVendorDataRequest?: PutVendorDataRequest, options?: any): AxiosPromise<PutNewsData200Response> {
            return localVarFp.putVendorData(vendorId, putVendorDataRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary メッセージ 削除
     * @param {number} messageId メッセージID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMessageData(messageId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMessageData(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary お知らせ 削除
     * @param {number} newsId お知らせID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteNewsData(newsId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteNewsData(newsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ログアウト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSession(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加盟店 削除
     * @param {number} vendorId 加盟店ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteVendorData(vendorId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteVendorData(vendorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CSV 取得
     * @param {string} [name] 加盟店名
     * @param {number} [addressPrefectureId] 都道府県ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public exportVendor(name?: string, addressPrefectureId?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).exportVendor(name, addressPrefectureId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary CSRFトークン 取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCsrf(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCsrf(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ファイル URL 取得
     * @param {string} [path] パス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFile(path?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFile(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ファイル アップロードURL 取得
     * @param {string} [name] ファイル名
     * @param {string} [contentType] コンテンツタイプ
     * @param {number} [size] サイズ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFileUploadRequest(name?: string, contentType?: string, size?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFileUploadRequest(name, contentType, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 設定一覧 取得
     * @param {string} [name] 事故種別名
     * @param {number} [selectYear] 選択可能期間年数
     * @param {string} [accidentLocation] 事故箇所
     * @param {string} [accidentPart] 事故部分
     * @param {number} [page] ページ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getJskAccidentLocationSettingCollection(name?: string, selectYear?: number, accidentLocation?: string, accidentPart?: string, page?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getJskAccidentLocationSettingCollection(name, selectYear, accidentLocation, accidentPart, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メッセージ一覧 取得
     * @param {number} vendorId 加盟店ID
     * @param {number} [offset] 開始
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMessageCollection(vendorId: number, offset?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMessageCollection(vendorId, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メッセージ 取得
     * @param {number} vendorId 加盟店ID
     * @param {number} [messageId] メッセージID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMessageData(vendorId: number, messageId?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMessageData(vendorId, messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary お知らせ一覧 取得
     * @param {number} [page] ページ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getNewsCollection(page?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getNewsCollection(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary お知らせ 取得
     * @param {number} newsId お知らせID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getNewsData(newsId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getNewsData(newsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 通知 取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getNotification(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getNotification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 宛先 選択肢 取得
     * @param {number} [vendorId] 加盟店ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOptionDestination(vendorId?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOptionDestination(vendorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 都道府県 選択肢 取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOptionPrefecture(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOptionPrefecture(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary セッション 取得
     * @param {string} [xCSRFTOKEN] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSession(xCSRFTOKEN?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSession(xCSRFTOKEN, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加盟店一覧 取得
     * @param {string} [name] 加盟店名
     * @param {number} [addressPrefectureId] 都道府県ID
     * @param {number} [page] ページ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getVendorCollection(name?: string, addressPrefectureId?: number, page?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getVendorCollection(name, addressPrefectureId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加盟店 取得
     * @param {number} vendorId 加盟店ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getVendorData(vendorId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getVendorData(vendorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加盟店 メンバー 取得
     * @param {number} vendorId 加盟店ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getVendorMember(vendorId: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getVendorMember(vendorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  メッセージ 作成
     * @param {PostMessageDataRequest} [postMessageDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postMessageData(postMessageDataRequest?: PostMessageDataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postMessageData(postMessageDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary お知らせ 作成
     * @param {PutNewsDataRequest} [putNewsDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postNewsData(putNewsDataRequest?: PutNewsDataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postNewsData(putNewsDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パスワード リセット
     * @param {PostPasswordResetRequest} [postPasswordResetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postPasswordReset(postPasswordResetRequest?: PostPasswordResetRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postPasswordReset(postPasswordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パスワード リセット リクエスト
     * @param {PostPasswordResetRequestRequest} [postPasswordResetRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postPasswordResetRequest(postPasswordResetRequestRequest?: PostPasswordResetRequestRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postPasswordResetRequest(postPasswordResetRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ログイン
     * @param {PostSessionRequest} [postSessionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postSession(postSessionRequest?: PostSessionRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postSession(postSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 設定 作成
     * @param {PostSettingDataRequest} [postSettingDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postSettingData(postSettingDataRequest?: PostSettingDataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postSettingData(postSettingDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加盟店 作成
     * @param {PutVendorDataRequest} [putVendorDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public postVendorData(putVendorDataRequest?: PutVendorDataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).postVendorData(putVendorDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary  メッセージ 既読
     * @param {PutMessageReadRequest} [putMessageReadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putMessageRead(putMessageReadRequest?: PutMessageReadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putMessageRead(putMessageReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary お知らせ 更新
     * @param {number} newsId お知らせID
     * @param {PutNewsDataRequest} [putNewsDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putNewsData(newsId: number, putNewsDataRequest?: PutNewsDataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putNewsData(newsId, putNewsDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 設定 更新
     * @param {number} settingId 事故種別ID
     * @param {PostSettingDataRequest} [postSettingDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putSettingData(settingId: number, postSettingDataRequest?: PostSettingDataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putSettingData(settingId, postSettingDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 加盟店 更新
     * @param {number} vendorId 加盟店ID
     * @param {PutVendorDataRequest} [putVendorDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public putVendorData(vendorId: number, putVendorDataRequest?: PutVendorDataRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).putVendorData(vendorId, putVendorDataRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



